// extracted by mini-css-extract-plugin
export default {"item":"CatalogItem_item__DZ1-i","btn":"CatalogItem_btn__Lcobi","image":"CatalogItem_image__Jo7Hw","text":"CatalogItem_text__oaKJP","sliderWrapper":"CatalogItem_sliderWrapper__9PUZT"};